import { lazy } from "react";
import Loadable from "app/components/Loadable";
import CollateralType from "./CollateralType";

const collateraltype = Loadable(lazy(() => import("./CollateralType")));

const collateraltypeRoute = [{ path: "/collateraltype", element: <CollateralType /> }];
export default collateraltypeRoute;
